import { render, staticRenderFns } from "./createKnowledgeDocs.vue?vue&type=template&id=47d9e0d6&scoped=true"
import script from "./createKnowledgeDocs.vue?vue&type=script&lang=js"
export * from "./createKnowledgeDocs.vue?vue&type=script&lang=js"
import style0 from "./createKnowledgeDocs.vue?vue&type=style&index=0&id=47d9e0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9e0d6",
  null
  
)

export default component.exports